/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Knowledge_Assistants_Cite_Desc4Inputs */

const en_svc_rag_knowledge_assistants_cite_desc4 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Cite_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every answer links its sources. Unknown questions get an honest handoff, not a guess.`)
};

const ar_svc_rag_knowledge_assistants_cite_desc4 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Cite_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كل إجابة تربط مصادرها. الأسئلة المجهولة تحصل على تسليم صادق، لا تخمين.`)
};

const bn_svc_rag_knowledge_assistants_cite_desc4 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Cite_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রতিটি উত্তর তার সূত্র লিঙ্ক করে। অজানা প্রশ্নে সৎ হস্তান্তর, আন্দাজ নয়।`)
};

const de_svc_rag_knowledge_assistants_cite_desc4 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Cite_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jede Antwort verlinkt ihre Quellen. Unbekannte Fragen erhalten eine ehrliche Übergabe, kein Raten.`)
};

const es_svc_rag_knowledge_assistants_cite_desc4 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Cite_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada respuesta enlaza sus fuentes. Las preguntas desconocidas reciben una derivación honesta, no una adivinanza.`)
};

const fr_svc_rag_knowledge_assistants_cite_desc4 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Cite_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque réponse lie ses sources. Les questions inconnues reçoivent un relais honnête, pas une devinette.`)
};

const pt_svc_rag_knowledge_assistants_cite_desc4 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Cite_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada resposta liga as suas fontes. Perguntas desconhecidas recebem uma passagem honesta, não um palpite.`)
};

const zh_svc_rag_knowledge_assistants_cite_desc4 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Cite_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每个回答都附上来源。未知问题诚实转交人工，绝不猜测。`)
};

const tr_svc_rag_knowledge_assistants_cite_desc4 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Cite_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Her yanıt kaynağını bağlar. Bilinmeyen sorulara dürüst devir, tahmin değil.`)
};

const ru_svc_rag_knowledge_assistants_cite_desc4 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Cite_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Каждый ответ ссылается на источники. Незнакомые вопросы получают честную передачу, а не угадайку.`)
};

const pl_svc_rag_knowledge_assistants_cite_desc4 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Cite_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Każda odpowiedź linkuje źródła. Nieznane pytania dostają uczciwe przekazanie, nie zgadywanie.`)
};

/**
* | output |
* | --- |
* | "Every answer links its sources. Unknown questions get an honest handoff, not a guess." |
*
* @param {Svc_Rag_Knowledge_Assistants_Cite_Desc4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_rag_knowledge_assistants_cite_desc4 = /** @type {((inputs?: Svc_Rag_Knowledge_Assistants_Cite_Desc4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Knowledge_Assistants_Cite_Desc4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_rag_knowledge_assistants_cite_desc4(inputs)
	if (locale === "bn") return bn_svc_rag_knowledge_assistants_cite_desc4(inputs)
	if (locale === "de") return de_svc_rag_knowledge_assistants_cite_desc4(inputs)
	if (locale === "es") return es_svc_rag_knowledge_assistants_cite_desc4(inputs)
	if (locale === "fr") return fr_svc_rag_knowledge_assistants_cite_desc4(inputs)
	if (locale === "pt") return pt_svc_rag_knowledge_assistants_cite_desc4(inputs)
	if (locale === "zh") return zh_svc_rag_knowledge_assistants_cite_desc4(inputs)
	if (locale === "tr") return tr_svc_rag_knowledge_assistants_cite_desc4(inputs)
	if (locale === "ru") return ru_svc_rag_knowledge_assistants_cite_desc4(inputs)
	if (locale === "pl") return pl_svc_rag_knowledge_assistants_cite_desc4(inputs)
	return en_svc_rag_knowledge_assistants_cite_desc4(inputs)
});
export { svc_rag_knowledge_assistants_cite_desc4 as "svc_rag-knowledge-assistants_CITE_desc" }